module.exports = __webpack_public_path__ + "img/completo_sx.9c442d99.png";